jQuery(document).ready(function () {
	window.dispatchEvent(new Event('resize'));
});
jQuery(document).ready(function() {
	jQuery(window).scroll(function() {
	var sticky = jQuery('#header-component'),
	scroll = jQuery(window).scrollTop();
	if (scroll >= 100) sticky.addClass('fixed');
	else sticky.removeClass('fixed');
	});
});

// ---------------------- // NEW PREMIUM ANIMATIONS // ---------------------- //
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll('section, .shopify-section');
  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const section = entry.target;
        const animItems = section.querySelectorAll(
          '.img-mask '
        );
        const itemsArray = Array.from(animItems);
        itemsArray.sort((a, b) => {
          return a.getBoundingClientRect().left - b.getBoundingClientRect().left;
        });
        itemsArray.forEach((el, i) => {
          setTimeout(() => {
            el.classList.add('active');
          }, i * 500);
        });
        sectionObserver.unobserve(section);
      }
    });
  }, {
    threshold: 0.25
  });
  sections.forEach(section => sectionObserver.observe(section));
});


(function () {
  function updateHeaderClass() {
    const header = document.querySelector('.header');
    if (!header) return;
    const isOpen = document.querySelector(
      '.menu-list__list-item.has-submenu [aria-expanded="true"]'
    );
    header.classList.toggle('open-max-mega-menu', !!isOpen);
  }
  function bindMenuEvents() {
    const items = document.querySelectorAll('.menu-list__list-item.has-submenu');
    if (!items.length) return false;
    items.forEach(item => {
      item.addEventListener('mouseenter', updateHeaderClass);
      item.addEventListener('mouseleave', updateHeaderClass);
      const link = item.querySelector('a');
      if (link) {
        link.addEventListener('click', () => {
          setTimeout(updateHeaderClass, 50);
        });
      }
      item.querySelectorAll('[aria-expanded]').forEach(el => {
        observer.observe(el, {
          attributes: true,
          attributeFilter: ['aria-expanded']
        });
      });
    });

    updateHeaderClass();
    return true;
  }
  const observer = new MutationObserver(updateHeaderClass);
  let tries = 0;
  const retry = setInterval(() => {
    tries++;
    if (bindMenuEvents() || tries > 20) {
      clearInterval(retry);
    }
  }, 200);
  document.addEventListener('DOMContentLoaded', updateHeaderClass);
  document.addEventListener('shopify:section:load', updateHeaderClass);
})();


document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-btn");
  const panels = document.querySelectorAll(".tab-panel");
  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.getAttribute("data-tab");
      tabs.forEach(t => t.classList.remove("active"));
      panels.forEach(p => p.classList.remove("active"));
      tab.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".faq-item");
  items.forEach(item => {
    const btn = item.querySelector(".faq-question");
    btn.addEventListener("click", () => {
      const isActive = item.classList.contains("active");
      items.forEach(i => i.classList.remove("active"));
      if (!isActive) {
        item.classList.add("active");
      }
    });
  });
});


document.querySelectorAll('.view-products-btn').forEach(btn=>{
  btn.addEventListener('click',()=>{
    document.getElementById(btn.dataset.popup).classList.add('active')
  })
})

document.querySelectorAll('.close-popup').forEach(btn=>{
  btn.addEventListener('click',()=>{
    btn.closest('.products-popup').classList.remove('active')
  })
})


$(document).ready(function () {
  if ($('.hero-banner-image-row').length > 0) {
    $('body').addClass('available-banner');
  }
});


document.addEventListener("DOMContentLoaded", function () {
  var productTitle = document.querySelector(".breadcrumb-product-title");
  if (productTitle) {
    var text = productTitle.innerText.toLowerCase().split(" ");
    for (var i = 0; i < text.length; i++) {
      if (text[i].length > 0) {
        text[i] = text[i][0].toUpperCase() + text[i].substring(1);
      }
    }
    productTitle.innerText = text.join(" ");
  }
});

// ------------------------------ //
// OPTIMIZED PREMIUM ANIMATIONS   //
// ----------------------------- //
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;
    const mobileDuration  = 600;  
    const desktopDuration = 1000;
    const dur   = isMobile ? mobileDuration  : desktopDuration;
    const dist  = isMobile ? "30px"          : "50px";
    const scale = isMobile ? 0.98            : 0.97;
    const sr = ScrollReveal({
        reset: false,
        useDelay: "onload",   
        viewFactor: 0.10,
        viewOffset: { top: 0, right: 0, bottom: 0, left: 0 }
    });
    sr.reveal(
        [
            ".reveal",
            ".shopify-policy__body h1",
            ".shopify-policy__body h2",
            ".shopify-policy__body h3",
            ".shopify-policy__body p",
            ".shopify-policy__body ul li",
            ".care-container h1",
            ".care-container h2",
            ".care-container h3",
            ".care-container p",
            ".care-container ul li",
            ".product-top-row h3",
            ".product-top-row .button",
            ".furniture-tabs h6",
            ".tabs-header",
            ".faq-item",
            ".collection_title",
            ".mission-content p",
            ".mission-content .mission-small",
            ".mission-content h2",
            ".features-heading",
            ".craftsmanship-row p",
            ".contact-us h3",
            ".contact-us .text-block p",
            ".contact-form .contact-form__form",
            ".contact-form .contact-side .contact-side__info .info-block",
            ".faq-heading"
        ].join(", "),
        {
            delay: isMobile ? 100 : 200, 
            distance: dist,
            origin: "bottom",
            duration: dur,
            easing: "ease-in-out",
            interval: isMobile ? 60 : 100
        }
    );
    // ---------- 2. PRODUCT INFORMATION GRID ----------
    sr.reveal(
        ".reveal-bottom-item, .product-information .product-information__grid",
        {
            delay: isMobile ? 100 : 200,
            distance: dist,
            origin: "bottom",
            duration: dur,
            easing: "ease-in-out",
            interval: isMobile ? 120 : 200
        }
    );
    // ---------- 3. PRODUCT GRIDS / COLLECTIONS (fade + subtle scale) ----------
    sr.reveal(
        [
            ".fade-in-scroll",
            ".resource-list.featured-products",
            ".product-grid li",
            ".template-list-collections .resource-list.resource-list--grid .resource-list__item",
            ".resource-list--grid .resource-list__item"
        ].join(", "),
        {
            delay: 20,
            duration: isMobile ? 400 : 500,
            distance: "0px",
            opacity: 0,
            scale: isMobile ? 0.99 : 0.97, 
            easing: "ease-in-out",
            interval: isMobile ? 50 : 80   
        }
    );
    // ---------- 4. SECTIONS / RECOMMENDATIONS ----------
    sr.reveal(
        ".reveal-bottom, .product-recommendations .section-resource-list",
        {
            origin: "bottom",
            distance: dist,
            duration: dur
        }
    );
    // ---------- 5. ZOOM-IN ELEMENTS ----------
    sr.reveal(
        ".zoom-in, .facets.facets--horizontal, .jdgm-widget-row, .bottom_content",
        {
            duration: dur,
            scale: isMobile ? 0.92 : 0.85,
            opacity: 0,
            easing: "ease-out",
            reset: false
        }
    );
    // ---------- 6. ZOOM-OUT ELEMENTS ----------
    sr.reveal(
        ".zoom-out, .blog-post-featured-image__image",
        {
            scale: isMobile ? 1.08 : 1.2, 
            opacity: 0,
            duration: isMobile ? 800 : 1100,
            easing: "ease-out"
        }
    );
    // ---------- 7. SPLIT HERO IMAGES ----------
    sr.reveal(
        ".split-hero__item img",
        {
            delay: isMobile ? 40 : 80,
            duration: isMobile ? 800 : 1100,
            distance: isMobile ? "20px" : "35px",
            origin: "bottom",
            opacity: 0,
            scale: isMobile ? 1.01 : 1.02,
            easing: "cubic-bezier(0.22, 1, 0.36, 1)",
            reset: false,
            viewFactor: 0.3
        }
    );
    // ---------- 8. MISSION / CONTACT IMAGES (slide from left) ----------
    sr.reveal(
        ".mission-image img, .contact-side__image img",
        {
            delay: isMobile ? 60 : 100,
            duration: isMobile ? 900 : 1200,
            distance: isMobile ? "25px" : "40px",
            origin: "left",
            opacity: 0,
            scale: isMobile ? 1.01 : 1.02,
            easing: "cubic-bezier(0.4, 0, 0.2, 1)",
            reset: false,
            viewFactor: 0.35
        }
    );
});


